import { collection, getDocs, orderBy, query, where } from 'firebase/firestore';
import { useCallback, useState } from 'react';
import { db } from '../../../core/services/firebase';

export function useCertificates(uid) {
  const [certificates, setCertificates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [raceNames, setRaceNames] = useState([]);
  const [selectedRace, setSelectedRace] = useState('all');

  const fetchCertificates = useCallback(async () => {
    if (!uid) return;
    setLoading(true);
    try {
      const snapshot = await getDocs(
        query(
          collection(db, 'certificates'),
          where('uid', '==', uid),
          where('deletedAt', '==', null),
          orderBy('eventDate', 'desc')
        )
      );
      const docs = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      setCertificates(docs);
      setRaceNames([...new Set(docs.map((d) => d.eventName))]);
    } catch (err) {
      console.error('Failed to fetch certificates:', err);
    } finally {
      setLoading(false);
    }
  }, [uid]);

  const filteredCertificates =
    selectedRace === 'all' ? certificates : certificates.filter((c) => c.eventName === selectedRace);

  const removeCertificate = (docId) => {
    setCertificates((prev) => prev.filter((c) => c.id !== docId));
  };

  const updateMemorandum = (docId, memorandum) => {
    setCertificates((prev) => prev.map((c) => (c.id === docId ? { ...c, memorandum } : c)));
  };

  return {
    certificates: filteredCertificates,
    allCertificates: certificates,
    loading,
    raceNames,
    selectedRace,
    setSelectedRace,
    fetchCertificates,
    removeCertificate,
    updateMemorandum,
  };
}
